var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer block mr-2 mt-3 rounded-md py-2 text-gray-200 border-white-600 \n        font-semibold border-2 hover:text-white hover:border-primary-400"},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }